var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.547 7.36368C15.547 6.92969 15.3746 6.51347 15.0677 6.2066C14.7608 5.89972 14.3446 5.72732 13.9106 5.72732H12.8197V2.45459H5.18333V5.72732H4.09242C3.65843 5.72732 3.24221 5.89972 2.93533 6.2066C2.62846 6.51347 2.45605 6.92969 2.45605 7.36368V13.9091H5.18333V15.5455H12.8197V13.9091H15.547V7.36368ZM6.27424 3.5455H11.7288V5.72732H6.27424V3.5455ZM11.7288 14.4546H6.27424V11.1819H11.7288V14.4546ZM14.4561 12.8182H12.8197V10.091H5.18333V12.8182H3.54696V7.36368C3.54696 7.21902 3.60443 7.08028 3.70672 6.97799C3.80902 6.87569 3.94775 6.81823 4.09242 6.81823H13.9106C14.0553 6.81823 14.194 6.87569 14.2963 6.97799C14.3986 7.08028 14.4561 7.21902 14.4561 7.36368V12.8182Z",
    fill: "#26445A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8195 7.90894H10.6377V8.99984H12.8195V7.90894Z",
    fill: "#26445A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.4d53c81cb4b7aedd2c9ae4d45ec7c716.svg";
export { ForwardRef as ReactComponent };